import { parseInboundPayload } from '../inbound';
import { booleanParser, createArrayWithBracesParser, encodedStringParser, numberArrayParser, numberParser, stringParser } from '../inboundParsers';
import { splitWithBraces, trimBraces } from '../inboundUtils';
import { communityCardsWithIndexesParser, revealedCardsParser, seatIndexParser } from './utils/pokerInboundUtils';
function handRankOrdinalParser(str) {
    return Number(str);
}
function handRankParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, handRankPartDefinitions);
}
const handRankPartDefinitions = [
    { name: 'handRankOrdinal', parser: handRankOrdinalParser },
    { name: 'kickerChart', parser: numberArrayParser }
];
const winningCardsPartDefinitions = [
    { name: 'seatIndex', parser: seatIndexParser },
    { name: 'numRankedCards', parser: numberParser },
    { name: 'handCardIndexes', parser: numberArrayParser }
];
function winningCardsParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, winningCardsPartDefinitions);
}
const inboundShowdownPartDefinitions = [
    { name: 'potAmounts', parser: numberArrayParser },
    { name: 'potIndex', parser: numberParser },
    { name: 'winningCards', parser: createArrayWithBracesParser(winningCardsParser) },
    { name: 'chipsWonPerPlayer', parser: numberParser },
    { name: 'actionHtml', parser: encodedStringParser },
    { name: 'playerShowdownInfos', parser: createArrayWithBracesParser(playerShowdownInfoParser) },
    { name: 'rabbits', parser: communityCardsWithIndexesParser },
    { name: 'rakeAmountTaken', parser: numberParser },
    { name: 'handRank', parser: handRankParser }
];
const playerShowdownInfoPartDefinitions = [
    { name: 'playerId', parser: numberParser },
    { name: 'seatIndex', parser: seatIndexParser },
    { name: 'isShowingCards', parser: booleanParser },
    { name: 'revealedCards', parser: revealedCardsParser },
    { name: 'numChips', parser: numberParser },
    { name: 'numChipsInBank', parser: numberParser },
    { name: 'numPoints', parser: numberParser }
];
function playerShowdownInfoParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, playerShowdownInfoPartDefinitions);
}
function inboundShowdownParser(str) {
    const inboundParts = splitWithBraces(trimBraces(str));
    return parseInboundPayload(inboundParts, inboundShowdownPartDefinitions);
}
export const HAND_WIN_INBOUND_DEFINITION = {
    shouldSplitWithBraces: true,
    definitionParts: [
        { name: 'inboundShowdowns', parser: createArrayWithBracesParser(inboundShowdownParser) },
        { name: 'playerPointsStrings', parser: stringParser }, // TODO
        { name: 'isEmptyShowdown', parser: booleanParser },
        { name: 'isTourneyDone', parser: booleanParser }
    ]
};
